import { addPolicyType } from "../../../../../actions/Utilities/ConfigureAgreement";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";
import { policyTypeData } from "../types/PolicyTypeInterface";

const useAddPolicyType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (PolicyTypeTypeNewData: policyTypeData) =>
      addPolicyType(PolicyTypeTypeNewData),
    {
      onSuccess: (res: any) => {
        if (res === "Duplicate") {
          toast.fire("Saving Failed", "The data already exists!", "error");
        } else {
          queryClient.invalidateQueries(["GetPolicyType"]);
          toast.fire("Success", "Policy Type Updated Successfully", "success");
        }
      },
      onError: (error) => {
        toast.fire("Failed", "Failed to Add Policy Type", "error");
      },
    }
  );

  return mutate;
};
export default useAddPolicyType;
